<template>
    <div id="app">
        <b-spinner v-show="loading" class="loading" type="grow" label="Loading..."></b-spinner>
        <Header />
        <b-tabs
                pills
                card
        >
            <b-tab title="每日" active>
                <div v-if="chartDailyDataList.length > 0">
                    <Chart v-for="item in chartDailyDataList" :key="item.name" :origin-data="item.data"
                           :name="item.name" />
                </div>
            </b-tab>
            <b-tab title="数据查询">
                <div>
                    <Table :list="originData" />
                </div>
            </b-tab>
            <b-tab title="数据统计">
                <StaticTableList :originData="originData" />
            </b-tab>
            <b-tab title="医护人员牺牲名单" title-link-class="dark" style="background: #2c3e50;color: white">
                <MedicalStaffSacrificeList />
            </b-tab>
            <b-tab title="说明">
                <Info />
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import Header from './components/header.vue'
    import Table from './components/table.vue'
    import Chart from './components/chart.vue'
    import MedicalStaffSacrificeList from './components/MedicalStaffSacrificeList.vue'
    import Info from './components/info.vue'
    import { chartLineSeriesNameList, ProductType, timeArray } from './constant'
    import { FormatData, getTotalCount } from './utils';
    import StaticTableList from './components/StaticTableList';

    export default {
        name: 'App',
        components: {
            StaticTableList,
            Header,
            Table,
            MedicalStaffSacrificeList,
            Info,
            Chart
        },
        data() {
            return {
                tempListData: [],
                originData: [],
                chartDailyData: {},
                chartDailyDataList: [],
                timeArray,
                toggleFilterValue: false,
                loading: true,
            }
        },
        computed: {},
        methods: {
            renderData(time) {
                return this.$axios.get(`./${time}.json`)
                    .then(response => {
                        const formatData = FormatData({
                            data: response.data,
                            time
                        })
                        this.tempListData = this.tempListData.concat(formatData)
                        this.chartDailyData[time] = formatData;
                    })
            },
            renderChartListData() {
                const chartDailyDataList = [];
                ProductType.map(product => {
                    const chartDailyDataListItem = {};
                    chartLineSeriesNameList.map(seriesName => {
                        timeArray.map(time => {
                            const data = this.chartDailyData[time].filter(item =>
                                item['接收单位类型'] == seriesName && item['物资类型'] == product.value
                            )
                            if (chartDailyDataListItem[seriesName]) {
                                chartDailyDataListItem[seriesName].push(getTotalCount(data))
                            } else {
                                chartDailyDataListItem[seriesName] = [getTotalCount(data)]
                            }
                        })
                    })
                    chartDailyDataList.push({
                        name: product.value,
                        data: chartDailyDataListItem
                    })
                })
                this.chartDailyDataList = chartDailyDataList
            },
            renderOriginData() {
                this.originData = this.tempListData
            },
        },
        mounted() {
            let ajaxAll = this.timeArray.map(item => this.renderData(item))
            Promise.all(ajaxAll)
                .then(() => {
                    this.renderChartListData()
                    this.renderOriginData()
                    this.loading = false
                })
        }
    }
</script>

<style>
    #app {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        margin-top: 20px;
    }

    body {
        font-size: 16px;
        width: 100vw;
        padding: 1%;
    }


    .loading {
        width: 10em;
        height: 10em;
        position: absolute;
        top: calc(50% - 5em );
        left: calc(50% - 5em );
    }
</style>
